import { getItem } from "../utils/nauth";
import {
  AccountServerType,
  DomainType,
  ServerType,
  ServiceType,
  TemplatesServerType,
} from "./types";
import { Cookies } from "react-cookie";

/**
 * nAuth Token 값을 스토리지에서 받아와서 리턴
 * @returns token : string
 */
export const getToken = () => {
  return getItem("ntoken");
};

/**
 * 현재 도메인 값으로 Upload API BaseUrl 을 리턴
 * @returns baseUrl : string
 */
export const getBaseUrl = () => {
  const CONSTANTS: DomainType = {
    LOCAL_URL: "http://localhost:3000/",
    TEST_URL: "https://test-templates-console.kinemaster.com/",
    PROD_URL: "https://templates-console.kinemaster.com/",
    LOCAL_API_DOMAIN: "https://test-api-upload-console.kinemasters.com",
    TEST_API_DOMAIN: "https://test-api-upload-console.kinemasters.com",
    PROD_API_DOMAIN: "https://api-upload-console.kinemasters.com",
    MUMBAI_PROD_API_DOMAIN: "https://api-upload-console-mumbai.kinemasters.com",
    SINGAPORE_PROD_API_DOMAIN:
      "https://api-upload-console-singapore.kinemasters.com",
    SEOUL_PROD_API_DOMAIN: "https://api-upload-console-seoul.kinemasters.com",
  };

  const { href } = window.location;

  const cookies = new Cookies();
  const getCookie = (item: string) => {
    return cookies.get(item);
  };

  if (href.includes(CONSTANTS.LOCAL_URL)) {
    return CONSTANTS.LOCAL_API_DOMAIN;
  }
  if (href.includes(CONSTANTS.TEST_URL)) {
    return CONSTANTS.TEST_API_DOMAIN;
  }
  if (href.includes(CONSTANTS.PROD_URL)) {
    if (getCookie("region") && getCookie("region") === "singapore") {
      return CONSTANTS.SINGAPORE_PROD_API_DOMAIN;
    } else if (getCookie("region") && getCookie("region") === "mumbai") {
      return CONSTANTS.MUMBAI_PROD_API_DOMAIN;
    } else if (getCookie("region") && getCookie("region") === "seoul") {
      return CONSTANTS.SEOUL_PROD_API_DOMAIN;
    } else {
      return CONSTANTS.PROD_API_DOMAIN;
    }
  }

  return "DOMAIN_NOT_FOUND";
};

/**
 * 현재 도메인 값으로 History API BaseUrl 을 리턴
 * @returns baseUrl : string
 */
export const getHistoryBaseUrl = () => {
  const CONSTANTS: DomainType = {
    LOCAL_URL: "http://localhost:3000/",
    TEST_URL: "https://test-templates-console.kinemaster.com/",
    PROD_URL: "https://templates-console.kinemaster.com/",
    LOCAL_API_DOMAIN: "https://test-api-console-history.kinemasters.com",
    TEST_API_DOMAIN: "https://test-api-console-history.kinemasters.com",
    PROD_API_DOMAIN: "https://api-console-history.kinemasters.com",
  };

  const { href } = window.location;

  if (href.includes(CONSTANTS.LOCAL_URL)) {
    return CONSTANTS.LOCAL_API_DOMAIN;
  }
  if (href.includes(CONSTANTS.TEST_URL)) {
    return CONSTANTS.TEST_API_DOMAIN;
  }
  if (href.includes(CONSTANTS.PROD_URL)) {
    return CONSTANTS.PROD_API_DOMAIN;
  }

  return "DOMAIN_NOT_FOUND";
};

/**
 * 현재 도메인값으로 Server Type 을 리턴
 * @returns serverType : string
 */
export const getServerType = () => {
  const CONSTANTS: ServerType = {
    LOCAL_URL: "http://localhost:3000/",
    TEST_URL: "https://test-templates-console.kinemaster.com/",
    PROD_URL: "https://templates-console.kinemaster.com/",
    LOCAL_SERVER_TYPE: "development",
    TEST_SERVER_TYPE: "test",
    PROD_SERVER_TYPE: "production",
  };

  const { href } = window.location;

  if (href.includes(CONSTANTS.LOCAL_URL)) {
    return CONSTANTS.LOCAL_SERVER_TYPE;
  } else if (href.includes(CONSTANTS.TEST_URL)) {
    return CONSTANTS.TEST_SERVER_TYPE;
  } else if (href.includes(CONSTANTS.PROD_URL)) {
    return CONSTANTS.PROD_SERVER_TYPE;
  } else {
    return "";
  }
};

/**
 * 현재 도메인값으로 Service Name 을 리턴
 * @returns serviceName : string
 */

export const getServiceName = () => {
  const CONSTANTS: ServiceType = {
    LOCAL_URL: "http://localhost:3000/",
    TEST_URL: "https://test-templates-console.kinemaster.com/",
    PROD_URL: "https://templates-console.kinemaster.com/",
    LOCAL_SERVICE_NAME: "dev-templates-console",
    TEST_SERVICE_NAME: "test-templates-console",
    PROD_SERVICE_NAME: "prod-templates-console",
  };

  const { href } = window.location;

  if (href.includes(CONSTANTS.LOCAL_URL)) {
    return CONSTANTS.LOCAL_SERVICE_NAME;
  }
  if (href.includes(CONSTANTS.TEST_URL)) {
    return CONSTANTS.TEST_SERVICE_NAME;
  }
  if (href.includes(CONSTANTS.PROD_URL)) {
    return CONSTANTS.PROD_SERVICE_NAME;
  }

  return "not found";
};

/**
 * 현재 도메인값으로 Account Server Type 을 리턴
 * @returns AccountServerType : string
 */
export const getAccountServerType = () => {
  const CONSTANTS: AccountServerType = {
    LOCAL_URL: "http://localhost:3000/",
    TEST_URL: "https://test-templates-console.kinemaster.com/",
    PROD_URL: "https://templates-console.kinemaster.com/",
    ACCOUNT_LOCAL_SERVER_TYPE:
      "https://test-account-console.kinemaster.com/users",
    ACCOUNT_TEST_SERVER_TYPE:
      "https://test-account-console.kinemaster.com/users",
    ACCOUNT_PROD_SERVER_TYPE: "https://account-console.kinemaster.com/users",
  };

  const { href } = window.location;

  if (href.includes(CONSTANTS.LOCAL_URL)) {
    return CONSTANTS.ACCOUNT_LOCAL_SERVER_TYPE;
  } else if (href.includes(CONSTANTS.TEST_URL)) {
    return CONSTANTS.ACCOUNT_TEST_SERVER_TYPE;
  } else if (href.includes(CONSTANTS.PROD_URL)) {
    return CONSTANTS.ACCOUNT_PROD_SERVER_TYPE;
  } else {
    return "";
  }
};

/**
 * 현재 도메인값 가져오기
 * @returns TemplatesServerType : string
 */
export const getTemplatesServerType = () => {
  const CONSTANTS: TemplatesServerType = {
    LOCAL_URL: "http://localhost:3000/",
    TEST_URL: "https://test-templates-console.kinemaster.com/",
    PROD_URL: "https://templates-console.kinemaster.com/",
    TEMPLATES_LOCAL_SERVER_TYPE: "http://localhost:3000/",
    TEMPLATES_TEST_SERVER_TYPE:
      "https://test-templates-console.kinemaster.com/",
    TEMPLATES_PROD_SERVER_TYPE: "https://templates-console.kinemaster.com/",
  };
  const { href } = window.location;

  if (href.includes(CONSTANTS.LOCAL_URL)) {
    return CONSTANTS.TEMPLATES_LOCAL_SERVER_TYPE;
  } else if (href.includes(CONSTANTS.TEST_URL)) {
    return CONSTANTS.TEMPLATES_TEST_SERVER_TYPE;
  } else if (href.includes(CONSTANTS.PROD_URL)) {
    return CONSTANTS.TEMPLATES_PROD_SERVER_TYPE;
  } else {
    return "";
  }
};

/**
 *  Dynamic Links Analytics BaseUrl
 *
 *  @return baseUrl : string
 */
export const getAnalyticsBaseUrl = () => {
  const CONSTANTS = {
    LOCAL_URL: "http://localhost:3000/",
    TEST_URL: "https://test-templates-console.kinemaster.com/",
    PROD_URL: "https://templates-console.kinemaster.com/",
    LOCAL_API_URL: "http://localhost:3000/",
    TEST_API_URL:
      "https://test-api-account-console.kinemasters.com/link/statistics/",
    PROD_API_URL:
      "https://api-account-console.kinemasters.com/link/statistics/",
  };
  const { href } = window.location;

  if (href.includes(CONSTANTS.LOCAL_URL)) {
    return CONSTANTS.TEST_API_URL;
  } else if (href.includes(CONSTANTS.TEST_URL)) {
    return CONSTANTS.TEST_API_URL;
  } else if (href.includes(CONSTANTS.PROD_URL)) {
    return CONSTANTS.PROD_API_URL;
  } else {
    return "";
  }
};

/**
 * 현재 도메인 값으로 Jira BaseUrl 을 리턴
 * @returns baseUrl : string
 */
export const getJiraUrl = () => {
  const CONSTANTS: DomainType = {
    LOCAL_URL: "http://localhost:3000/",
    TEST_URL: "https://test-templates-console.kinemaster.com/",
    PROD_URL: "https://templates-console.kinemaster.com/",
    LOCAL_API_DOMAIN:
      "https://kinemastercorp.atlassian.net/jira/core/projects/KMPT3/issues",
    TEST_API_DOMAIN:
      "https://kinemastercorp.atlassian.net/jira/core/projects/KMPT3/issues",
    PROD_API_DOMAIN:
      "https://kinemastercorp.atlassian.net/jira/core/projects/KMPP/issues",
  };

  const { href } = window.location;

  if (href.includes(CONSTANTS.LOCAL_URL)) {
    return CONSTANTS.LOCAL_API_DOMAIN;
  }
  if (href.includes(CONSTANTS.TEST_URL)) {
    return CONSTANTS.TEST_API_DOMAIN;
  }
  if (href.includes(CONSTANTS.PROD_URL)) {
    return CONSTANTS.PROD_API_DOMAIN;
  }

  return "DOMAIN_NOT_FOUND";
};
